/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type UpdateProjectForm = {
  /**
   * The display name of the project
   */
  name: string;
};

/** @internal */
export type UpdateProjectForm$Outbound = {
  name: string;
};

/** @internal */
export const UpdateProjectForm$outboundSchema: z.ZodMiniType<
  UpdateProjectForm$Outbound,
  UpdateProjectForm
> = z.object({
  name: z.string(),
});

export function updateProjectFormToJSON(
  updateProjectForm: UpdateProjectForm,
): string {
  return JSON.stringify(
    UpdateProjectForm$outboundSchema.parse(updateProjectForm),
  );
}
